module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 104);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ role_select_dialog_RoleSelectDialog; });

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(2);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(7);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(4);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(5);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/possibleConstructorReturn"
var possibleConstructorReturn_ = __webpack_require__(8);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/getPrototypeOf"
var getPrototypeOf_ = __webpack_require__(6);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/inherits"
var inherits_ = __webpack_require__(9);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits_);

// EXTERNAL MODULE: external "@babel/runtime/regenerator"
var regenerator_ = __webpack_require__(0);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/helper"
var helper_ = __webpack_require__(3);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/user"
var user_ = __webpack_require__(20);
var user_default = /*#__PURE__*/__webpack_require__.n(user_);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/dialog"
var dialog_ = __webpack_require__(14);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog_);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/account-bar"
var account_bar_ = __webpack_require__(39);
var account_bar_default = /*#__PURE__*/__webpack_require__.n(account_bar_);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/zone-role-select"
var zone_role_select_ = __webpack_require__(40);
var zone_role_select_default = /*#__PURE__*/__webpack_require__.n(zone_role_select_);

// CONCATENATED MODULE: ./src/comps/business/role-select-dialog/template.js

/* harmony default export */ var template = (function (_ref) {
  var accountTip = _ref.accountTip;
  return "\n  <p class=\"account-tip-txt\">\n    <span>".concat(accountTip, "\uFF1A</span>\n    <span class=\"js-bind-user-nick\"></span>\n    <span>\uFF08").concat(Object(helper_["getOs"])(), "\uFF09</span>\n  </p>\n");
});
// CONCATENATED MODULE: ./src/comps/business/role-select-dialog/index.js








function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var role_select_dialog_RoleSelectDialog = /*#__PURE__*/function (_Dialog) {
  function RoleSelectDialog(container, options) {
    var _this;
    classCallCheck_default()(this, RoleSelectDialog);
    _this = _callSuper(this, RoleSelectDialog, [container, _objectSpread(_objectSpread({
      gameId: '',
      // 区服存储 localstorage 拼接字
      prefix: 'athena',
      // 展示账号信息时的文案，可以是"领取账号"，"绑定账号"等
      accountTip: '领取账号'
    }, options), {}, {
      // className需要固定一个role-select-dialog 可以不需要顾及index.scss的样式
      className: "role-select-dialog ".concat(options.className || '')
    })]);

    // gameId为必传参数
    var gameId = _this.options.gameId;
    if (!gameId) {
      throw new Error('错误：角色选择弹框缺少游戏ID参数');
    }
    _this.renderHeader();
    _this.renderBody();
    return _this;
  }
  inherits_default()(RoleSelectDialog, _Dialog);
  return createClass_default()(RoleSelectDialog, [{
    key: "renderHeader",
    value: function renderHeader() {
      var _this2 = this;
      var $dialogHeader = this.$header;

      // 切换角色bar
      var dialogAccount = new account_bar_default.a($dialogHeader);
      dialogAccount.on('account-click', /*#__PURE__*/asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              !Object(helper_["isTenvideo"])() && _this2.toggle();
              _context.next = 3;
              return user_default.a.changeLogin({
                inRefresh: true
              });
            case 3:
              !Object(helper_["isTenvideo"])() && _this2.toggle();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var options = this.options;
      var gameId = options.gameId,
        prefix = options.prefix,
        accountTip = options.accountTip;
      var $dialogBody = this.$body;

      // 领取角色提示展示
      $dialogBody.html(template({
        accountTip: accountTip
      }));
      user_default.a.mainUserInfo().then(function (res) {
        var code = res.code,
          _res$result = res.result,
          result = _res$result === void 0 ? {} : _res$result;
        var _result$nickname = result.nickname,
          nickname = _result$nickname === void 0 ? '' : _result$nickname;
        if (code === 0) {
          $dialogBody.find('.js-bind-user-nick').html(nickname);
        }
      });

      // 选择游戏区服角色信息
      this.zoneSelect = new zone_role_select_default.a($dialogBody, {
        gameId: gameId,
        prefix: prefix
      });
    }
  }]);
}(dialog_default.a);

;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/dialog");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/user");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/helper");

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/account-bar");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/zone-role-select");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inherits");

/***/ })

/******/ })["default"];